export default {
    exit: {
        execute(param, gameState) {
            // TODO: Current terminal
            gameState.nodes[gameState.currentNode].terminalVisible = false;
            return [{
                lines: [],
                startAt: 0,
                mute: true
            }];
        }
    }
}